module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1276"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1276"
    },
    "bundlingPackage": "EmailUnsubscribeUI",
    "bundlingPackageVersion": "static-1.11563",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};